module.exports = __webpack_public_path__ + "static/media/eu-Project.11232dff.png";